import { addProtocol } from '../../../utils/addProtocol';
import { makeTransition, TransitionType } from '../../../utils/styles/makeTransition';
import { useTranslation } from '../../../utils/useTranslation';
import { IconForward } from '../../icon/IconForward';
import { IconNewTab } from '../../icon/IconNewTab';
import { IconProduct } from '../../icon/IconProduct';
import { Button } from '../../input/Button';
import { Box } from '../../layout/Box';
import { PostCardProductButton } from './parts/PostCardProductButton/PostCardProductButton';
import { MainButton, ProductContainer, ProductContent, ProductMinizeButton } from './styles';
import { PostButtonProps } from './types';

export const PostButton = ({
    onClickOutClick,
    clickOut,
    products,
    businessType,
    isProductExpanded,
    transitionTiming,
    onProductButtonClick,
}: PostButtonProps) => {
    const t = useTranslation();

    if (products.items.length) {
        return (
            <MainButton onClick={onProductButtonClick}>
                <ProductMinizeButton
                    isProductExpanded={isProductExpanded}
                    transition={makeTransition({
                        ms: isProductExpanded ? 0 : transitionTiming,
                        styles: ['opacity'],
                        type: TransitionType.EASE_OUT,
                    })}
                >
                    <Box mr="10px">
                        <IconProduct size={20} />
                    </Box>
                    {t(products.buttonTitle)}
                </ProductMinizeButton>

                <ProductContainer
                    isProductExpanded={isProductExpanded}
                    transition={makeTransition({
                        ms: isProductExpanded ? transitionTiming : 0,
                        styles: ['opacity'],
                        type: TransitionType.EASE_OUT,
                    })}
                >
                    <ProductContent>
                        <PostCardProductButton products={products} businessType={businessType} />
                    </ProductContent>
                    <IconForward fontSize="16px" />
                </ProductContainer>
            </MainButton>
        );
    }

    if (clickOut) {
        return (
            <Button
                as="a"
                target="_blank"
                rel="nofollow noreferrer"
                flexGrow={1}
                href={addProtocol(clickOut.url)}
                color="hardLight"
                onClick={onClickOutClick}
                width="100%"
                fontSize="1rem"
            >
                {clickOut.text}
                <Box ml={1}>
                    <IconNewTab fontSize={14} color="#000" />
                </Box>
            </Button>
        );
    }

    return null;
};
